import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoadingPopupComponent } from '../../../../components/ui/loading-popup/loading-popup.component';
import { ModalSchedulerTaskComponent } from '../../../../components/ui/modal-scheduler-task/modal-scheduler-task.component';
import { SolarPriorityModalComponent } from '../../../../components/ui/solar-priority-modal/solar-priority-modal.component';
import { DeviceService } from '../../../../services/devices/device.service';
import { ModalService } from '../../../../services/modal/modal.service';
import { UtilsService } from '../../../../services/utils/utils.service';
import { compare } from 'compare-versions';

@Component({
    selector: 'app-power-scheduler',
    templateUrl: './power-scheduler.component.html',
    styleUrls: ['./power-scheduler.component.scss'],
    standalone: false
})
export class PowerSchedulerComponent implements OnInit {
  device: string;
  tasks: any[] = [];
  powerTasks: any;

  originalTasks: any = {};
  newTaskId: number;

  @Input()
  allSettings = false;

  @Input()
  connectors: any[];

  modalAdd: NgbModalRef;

  // selectedDays='weekday';

  successMessage: any;
  error: any = '';

  solarCfg: any;
  limitP: any;

  versionNewSchedulers: boolean = false;

  modalLoad: NgbModalRef;
  modalPriority: NgbModalRef;

  days: { [key: string]: boolean } = {
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: true,
    sunday: true,
  };

  daysOfWeek = [
    { label: 'L', value: 'monday' },
    { label: 'M', value: 'tuesday' },
    { label: 'X', value: 'wednesday' },
    { label: 'J', value: 'thursday' },
    { label: 'V', value: 'friday' },
    { label: 'S', value: 'saturday' },
    { label: 'D', value: 'sunday' },
  ];

  defaultTask = {
    id: 1,
    user: '',
    active: 1,
    group: 0,
    type: 1,
    maxPower: 0,
    priority: 1,
    solarPriority: 1,
    initTime: {
      day: 0,
      month: 0,
      weekday: 127,
      timeList: [
        {
          hourMin: 0,
          duration: 1440,
          maxPower: 0,
          phases: 0,
        },
      ],
    },
  };

  tasksToDelete: { tasks: any[] } = { tasks: [] };
  madeChanges = false;

  constructor(
    public _dService: DeviceService,
    private _aRoute: ActivatedRoute,
    private _modal: ModalService,
    public _utils: UtilsService,
  ) {}

  ngOnInit(): void {
    var deviceInfo = this._dService.getActiveDeviceInfo();
    this.versionNewSchedulers = compare(
      deviceInfo.firmware_version_name,
      '7.1.0',
      '>=',
    );

    this.tasks = [];
    this.powerTasks = {};

    this._aRoute.parent?.parent?.params.subscribe(
      (params: Params) => (this.device = params['serial']),
    );

    this._dService.getModuleInfo(this.device, 'modulator').subscribe((data) => {
      this.limitP = data.cfg.limitPower;
      console.log('limit P', this.limitP);
      // if (this.originalTasks['mennekes'].length === 0) {
      //   this.tasks[0].maxPower = this.limitP;
      //   console.log('tasks ', this.tasks);
      // }
    });

    setTimeout(() => {
      this.connectors.forEach((conn) => {
        if (conn.data.id != 1) return;
        this._dService
          .getElementModule(this.device, 'schedman', conn.name)
          .subscribe((data) => {
            let t = JSON.parse(data.cfg.tasks);
            this.tasks = t.filter((task) => task.type == 1);
            this.tasks = this.sortTasksByHourMin(this.tasks);

            if (this.versionNewSchedulers) {
              t.forEach((task) => {
                if (task?.initTime?.timeList[0])
                  task.maxPower = task.initTime.timeList[0].maxPower;
              });
            }
            if (this.tasks.length == 0) {
              this.defaultTask.maxPower = this.limitP;
              this.defaultTask.initTime.timeList[0].maxPower = this.limitP;
              this.tasks.push(this.defaultTask);
            }
            this.tasks = this.sortTasksByHourMin(this.tasks);

            this.tasksToDelete = {
              tasks: (this.tasks || [])
                .filter((t: any) => t.type == 1)
                .map((t: any) => ({ id: t.id, type: 1 })),
            };

            this.newTaskId = this.getFreeIdFromTasks();
            this.originalTasks[conn.name] = JSON.parse(data.cfg.tasks);
          });
      });

      this._dService.getModuleInfo(this.device, 'solar').subscribe((data) => {
        this.solarCfg = data.cfg;
      });
    }, 500);
  }

  openAddTask() {
    this.modalAdd = this._modal.open(ModalSchedulerTaskComponent);
    this.modalAdd.componentInstance.id = this.newTaskId;
    this.modalAdd.componentInstance.type = 1;
    this.modalAdd.componentInstance.weekday = 0;
    this.modalAdd.componentInstance.limitP = this.limitP;
    this.modalAdd.componentInstance.tasks = this.tasks;

    this.modalAdd.result.then(
      (task) => {
        if (this.isTareaCompleta(task)) {
          // Tarea de 24h: reclama esos días en exclusiva
          this.comprobarDiasTarea(task);
          this.tasks.push(task);
        } else {
          const newWeekday = this.normalizeWeekdayMask(task?.initTime?.weekday);
          // Tareas del mismo grupo exacto de días
          const sameGroupTasks = this.tasks.filter(
            (t) =>
              this.normalizeWeekdayMask(t?.initTime?.weekday) === newWeekday,
          );

          if (sameGroupTasks.length === 0) {
            // Sin cobertura previa para esos días → crear complementaria
            this.completarTarea(task);
          } else {
            // Ya existe cobertura → insertar y rebalancear el grupo
            // Excluir el mismo grupo de comprobarDiasTarea para no despojarlos de sus días
            const sameGroupIds = sameGroupTasks.map((t) => t.id);
            this.comprobarDiasTarea(task, sameGroupIds);
            this.tasks.push(task);
            this.rebalancearGrupoDias(newWeekday, task);
          }
        }
        this.tasks = this.sortTasksByHourMin(this.tasks);
        this.newTaskId = this.getFreeIdFromTasks();
        this.madeChanges = true;
      },
      (reason) => {
        // on dismiss
      },
    );
  }

  // Rebalancea un grupo de días aplicando prioridad real del nuevo tramo.
  // El nuevo rango recorta cualquier tarea existente que lo interseque,
  // manteniendo los fragmentos restantes fuera del rango insertado.
  rebalancearGrupoDias(weekday: number, newTask: any) {
    const newStart = newTask?.initTime?.timeList?.[0]?.hourMin;
    const newDuration = newTask?.initTime?.timeList?.[0]?.duration;

    if (
      typeof newStart !== 'number' ||
      typeof newDuration !== 'number' ||
      newDuration <= 0 ||
      newDuration > 1440
    ) {
      return;
    }

    const dayTasks = this.tasks.filter(
      (t) => this.normalizeWeekdayMask(t?.initTime?.weekday) === weekday,
    );
    const otherTasks = this.tasks.filter(
      (t) => this.normalizeWeekdayMask(t?.initTime?.weekday) !== weekday,
    );

    const existingTasks = dayTasks.filter((t) => t.id !== newTask.id);
    const cutSegments = this.buildSegmentsFromRange(newStart, newDuration);

    const rebuiltDayTasks: any[] = [newTask];
    const usedIds = new Set<number>();
    this.tasks.forEach((t) => {
      if (typeof t?.id === 'number') usedIds.add(t.id);
    });

    existingTasks.forEach((originalTask) => {
      let remainingSegments = this.buildSegmentsFromTask(originalTask);

      cutSegments.forEach((cut) => {
        remainingSegments = remainingSegments.flatMap((segment) =>
          this.subtractSegment(segment, cut),
        );
      });

      remainingSegments.forEach((segment, index) => {
        const clone = JSON.parse(JSON.stringify(originalTask));
        if (index === 0) {
          clone.id = originalTask.id;
        } else {
          clone.id = this.getNextFreeId(usedIds);
          usedIds.add(clone.id);
        }

        clone.initTime.timeList[0].hourMin = segment.start;
        clone.initTime.timeList[0].duration = segment.end - segment.start;

        if (clone.initTime.timeList[0].duration > 0) {
          rebuiltDayTasks.push(clone);
          usedIds.add(clone.id);
        }
      });
    });

    this.tasks = this.sortTasksByHourMin([...otherTasks, ...rebuiltDayTasks]);
  }

  private buildSegmentsFromTask(
    task: any,
  ): Array<{ start: number; end: number }> {
    const start = task?.initTime?.timeList?.[0]?.hourMin;
    const duration = task?.initTime?.timeList?.[0]?.duration;

    if (
      typeof start !== 'number' ||
      typeof duration !== 'number' ||
      duration <= 0 ||
      duration > 1440
    ) {
      return [];
    }

    return this.buildSegmentsFromRange(start, duration);
  }

  private buildSegmentsFromRange(
    start: number,
    duration: number,
  ): Array<{ start: number; end: number }> {
    if (duration === 1440) {
      return [{ start: 0, end: 1440 }];
    }

    const normalizedStart = ((start % 1440) + 1440) % 1440;
    const end = (normalizedStart + duration) % 1440;

    if (end > normalizedStart) {
      return [{ start: normalizedStart, end }];
    }

    const segments: Array<{ start: number; end: number }> = [
      { start: normalizedStart, end: 1440 },
    ];

    if (end > 0) {
      segments.push({ start: 0, end });
    }

    return segments;
  }

  private subtractSegment(
    segment: { start: number; end: number },
    cut: { start: number; end: number },
  ): Array<{ start: number; end: number }> {
    if (cut.end <= segment.start || cut.start >= segment.end) {
      return [segment];
    }

    const result: Array<{ start: number; end: number }> = [];

    if (cut.start > segment.start) {
      result.push({
        start: segment.start,
        end: Math.min(cut.start, segment.end),
      });
    }

    if (cut.end < segment.end) {
      result.push({
        start: Math.max(cut.end, segment.start),
        end: segment.end,
      });
    }

    return result.filter((s) => s.end > s.start);
  }

  private getNextFreeId(usedIds: Set<number>): number {
    let nextId = 1;
    while (usedIds.has(nextId)) {
      nextId++;
    }
    return nextId;
  }

  isTareaCompleta(task) {
    return task?.initTime?.timeList?.[0]?.duration === 1440;
  }

  completarTarea(task, addMainTask: boolean = true) {
    // Calcular la hora de inicio y duración de la nueva tarea
    const startTimeList = task?.initTime?.timeList?.[0];
    if (!startTimeList) return;

    const newHourMin = (startTimeList.hourMin + startTimeList.duration) % 1440;
    const newDuration = 1440 - startTimeList.duration;

    // Primero añadir la tarea principal para que getFreeIdFromTasks no devuelva
    // un ID ya usado por ella al calcular el ID de la complementaria.
    // Evitar auto-eliminacion cuando la tarea ya existe en this.tasks (caso edicion).
    this.comprobarDiasTarea(task, [task?.id]);
    if (addMainTask) {
      this.tasks.push(task);
    }

    // Crear la complementaria DESPUÉS de que la tarea principal esté en this.tasks
    const newTask = {
      id: this.getFreeIdFromTasks(),
      user: task.user,
      active: 1,
      group: task.group,
      type: task.type,
      maxPower: task.maxPower,
      priority: task.priority,
      solarPriority: task.solarPriority,
      initTime: {
        day: task.initTime.day,
        month: task.initTime.month,
        weekday: task.initTime.weekday,
        timeList: [
          {
            hourMin: newHourMin,
            duration: newDuration,
            maxPower: task.maxPower,
            phases: 0,
          },
        ],
      },
    };
    this.tasks.push(newTask);
  }

  comprobarDiasTarea(task, excludedIds: number[] = []) {
    const rawNewWeekday = task?.initTime?.weekday;
    if (typeof rawNewWeekday !== 'number') return;

    // En este proyecto, 0 equivale a "todos los días".
    const newWeekday = rawNewWeekday === 0 ? 127 : rawNewWeekday & 127;
    const excludedSet = new Set<number>(
      excludedIds.filter((id): id is number => typeof id === 'number'),
    );
    const idsToDelete = new Set<number>();

    this.tasks.forEach((existingTask) => {
      if (excludedSet.has(existingTask?.id)) return;

      const existingRawWeekday = existingTask?.initTime?.weekday;
      if (typeof existingRawWeekday !== 'number') return;

      const existingWeekday =
        existingRawWeekday === 0 ? 127 : existingRawWeekday & 127;

      // Si no comparten ningún día, no hay nada que ajustar.
      if ((existingWeekday & newWeekday) === 0) return;

      const updatedWeekday = existingWeekday & (~newWeekday & 127);

      if (updatedWeekday === 0) {
        idsToDelete.add(existingTask.id);
      } else {
        existingTask.initTime.weekday = updatedWeekday;
      }
    });

    if (idsToDelete.size > 0) {
      this.tasks = this.tasks.filter(
        (existingTask) => !idsToDelete.has(existingTask.id),
      );
    }
  }

  saveConfig(tasks) {
    const payloadTasks = JSON.parse(JSON.stringify(tasks || []));

    payloadTasks.forEach((task) => {
      const timeItem = task?.initTime?.timeList?.[0];
      if (timeItem && typeof timeItem.hourMin === 'number') {
        timeItem.hourMin = timeItem.hourMin % 1440;
      }
    });

    if (this.versionNewSchedulers) {
      this._dService.deleteModule(this.device, 'schedman', this.tasksToDelete)
        .subscribe(() => {
          payloadTasks.forEach((task) => {
            if (task?.initTime?.timeList[0])
              task.initTime.timeList[0].maxPower = task.maxPower;
            delete task.initTime.timeList[0]._initLocaltime;
            delete task.initTime.timeList[0]._endLocaltime;
            delete task.initTime.timeList[0].phases;
            delete task.maxPower;
            delete task.validFrom;
            delete task.validTo;
            delete task.minCurrent;
            delete task.chargeRelated;
          });
          this._dService.setModuleCfg(this.device, { tasks: payloadTasks }, 'schedman')
            .subscribe(
              (data) => {
                this.writeTaskPostSave();
              },
              (err) => {
                this.error = err.error.message;
                this.modalLoad?.close();
                setTimeout(() => {
                  this.error = '';
                }, 10000);
              },
            );
        });
    } else {
      this._dService
        .setModuleElement(this.device, 'schedman', this.tasksToDelete)
        .subscribe(() => {
          this._dService
            .setModuleElement(this.device, 'schedman', { tasks: payloadTasks })
            .subscribe(
              (data) => {
                this.writeTaskPostSave();
              },
              (err) => {
                this.error = err.error.message;
                this.modalLoad?.close();
                setTimeout(() => {
                  this.error = '';
                }, 10000);
              },
            );
        });
    }
  }

  writeTaskPostSave() {
    this.madeChanges = false;
    this.successMessage = true;
    this.modalLoad?.close();
    setTimeout(() => {
      // this.ngOnInit();
      this.successMessage = false;
    }, 10000);
  }

  //Ajusta las duraciones de las tareas para que no se solapen y cubran todo el día, asumiendo que las tareas están ordenadas por hora de inicio
  adjustPowerTasks(tasks) {
    if (!Array.isArray(tasks) || tasks.length === 0) return;

    tasks.sort((t1, t2) => {
      const h1 = t1?.initTime?.timeList?.[0]?.hourMin ?? 0;
      const h2 = t2?.initTime?.timeList?.[0]?.hourMin ?? 0;
      return h1 - h2;
    });

    if (tasks.length === 1) {
      tasks[0].initTime.timeList[0].duration = 1440;
      return;
    }

    tasks.forEach((t, index) => {
      if (index == tasks.length - 1) {
        t.initTime.timeList[0].duration =
          1440 -
          t.initTime.timeList[0].hourMin +
          tasks[0].initTime.timeList[0].hourMin;
      } else {
        t.initTime.timeList[0].duration =
          tasks[index + 1].initTime.timeList[0].hourMin -
          t.initTime.timeList[0].hourMin;
      }
    });
  }

  newDeleteTask(id) {
    const taskToDelete = this.tasks.find((t) => t.id === id);
    if (!taskToDelete) {
      return;
    }

    this.madeChanges = true;

    const deletedWeekday = this.normalizeWeekdayMask(
      taskToDelete?.initTime?.weekday,
    );
    let result = this.tasks.filter((t) => t.id !== id);

    // Si no queda ninguna tarea, crear una por defecto para mantener configuración válida.
    if (result.length === 0) {
      const newDefault = JSON.parse(JSON.stringify(this.defaultTask));
      newDefault.id = 1;
      newDefault.maxPower = this.limitP;
      newDefault.initTime.weekday = 127;
      newDefault.initTime.timeList[0].maxPower = this.limitP;
      result.push(newDefault);
    }

    // 1) Intentar absorber hueco en tareas con exactamente los mismos días
    // (incluye la complementaria si existía).
    const sameWeekdayTasks = result.filter(
      (t) => this.normalizeWeekdayMask(t?.initTime?.weekday) === deletedWeekday,
    );

    if (sameWeekdayTasks.length > 0) {
      const others = result.filter(
        (t) =>
          this.normalizeWeekdayMask(t?.initTime?.weekday) !== deletedWeekday,
      );
      this.adjustPowerTasks(sameWeekdayTasks);
      result = [...others, ...sameWeekdayTasks];
    } else {
      // 2) Si no hay grupo con mismos días, asignar esos días al grupo más cercano
      // y recalcular para que absorba el hueco.
      result = this.distribuirDiasHuerfanos(deletedWeekday, result);

      const masksToRebalance = new Set<number>();
      result.forEach((t) => {
        const mask = this.normalizeWeekdayMask(t?.initTime?.weekday);
        if ((mask & deletedWeekday) !== 0) {
          masksToRebalance.add(mask);
        }
      });

      masksToRebalance.forEach((mask) => {
        const affected = result.filter(
          (t) => this.normalizeWeekdayMask(t?.initTime?.weekday) === mask,
        );
        const others = result.filter(
          (t) => this.normalizeWeekdayMask(t?.initTime?.weekday) !== mask,
        );
        this.adjustPowerTasks(affected);
        result = [...others, ...affected];
      });
    }

    this.tasks = this.sortTasksByHourMin(result);
    this.newTaskId = this.getFreeIdFromTasks();
    this.error = '';
  }

  writeTaskPostDelete(updatedTasks: any[]) {
    this.successMessage = true;

    this.tasks = updatedTasks;
    this.saveConfig(this.tasks);

    setTimeout(() => {
      this.successMessage = false;
    }, 10000);
  }

  getFreeIdFromTasks() {
    let idTaskDisp = 1;
    let found = false;

    let ids: any[] = [];

    this.tasks.forEach((t) => {
      ids.push(t.id);
    });

    if (!found) idTaskDisp++;

    // if(this.tasks['timeTasks'])
    //     this.tasks['timeTasks'].forEach(t => {
    //       ids.push(t.id);
    //     });

    while (!found) {
      if (ids.includes(idTaskDisp)) idTaskDisp++;
      else found = true;
    }

    return idTaskDisp;
  }

  openModalPriority(task) {
    this.modalPriority = this._modal.open(SolarPriorityModalComponent);
    const originalPriority = task.solarPriority;
    this.modalPriority.componentInstance.task = task;
    this.modalPriority.componentInstance.limitP = this.limitP;

    let a;
    if (task.solarPriority == 0) {
      a = 'green';
    } else if (task.solarPriority == 1) a = 'ac';
    else a = 'hybrid';

    this.modalPriority.componentInstance.modeSelected = a;
    this.modalPriority.result.then(
      (mode) => {
        if (mode == 'green') {
          task.maxPower = 0;
          task.solarPriority = 0;
        } else if (mode == 'ac') {
          task.maxPower = this.limitP;
          task.solarPriority = 1;
        } else {
          task.maxPower = this.limitP;
          task.solarPriority = 2;
        }
        if (task.solarPriority !== originalPriority) {
          this.madeChanges = true;
        }
      },
      (reason) => {
        // on dismiss
      },
    );
  }

  save() {
    console.log('tareas en save ', this.tasks);
    if (!this.checkTask(this.tasks)) {
      this.error =
        'Las tareas deben cubrir todas las horas de la semana y no estar solapadas';
      setTimeout(() => {
        this.error = '';
      }, 10000);
      return;
    }

    this.modalLoad = this._modal.open(LoadingPopupComponent);
    this.saveConfig(this.tasks);
  }

  checkPriority(task) {
    if (task.solarPriority != 1) {
      if (task.maxPower == 0) task.solarPriority = 0;
      else task.solarPriority = 2;
    }
  }

  // Comprueba que las tareas de un día no se solapen y cubran 24h (incluye cruces de medianoche)
  checkPowerTasks(tasks) {
    if (!Array.isArray(tasks)) return false;
    if (tasks.length == 0) return false;

    const segments: Array<{ start: number; end: number }> = [];

    for (const task of tasks) {
      const start = task?.initTime?.timeList?.[0]?.hourMin;
      const duration = task?.initTime?.timeList?.[0]?.duration;

      if (
        typeof start !== 'number' ||
        typeof duration !== 'number' ||
        start < 0 ||
        duration <= 0 ||
        duration > 1440
      ) {
        return false;
      }

      // Permitimos 24:00 (1440) como inicio de día y normalizamos en rango [0, 1439].
      const normalizedStart = start % 1440;

      if (duration === 1440) {
        if (tasks.length > 1) {
          return false;
        }

        segments.push({ start: 0, end: 1440 });
        continue;
      }

      const end = (normalizedStart + duration) % 1440;

      if (end > normalizedStart) {
        segments.push({ start: normalizedStart, end });
      } else {
        segments.push({ start: normalizedStart, end: 1440 });
        // Si termina exactamente a las 00:00, el tramo [0,0] es vacío y no debe añadirse.
        if (end > 0) {
          segments.push({ start: 0, end });
        }
      }
    }

    segments.sort((a, b) => a.start - b.start);

    if (segments.length === 0 || segments[0].start !== 0) {
      return false;
    }

    let previousEnd = 0;
    for (const segment of segments) {
      if (segment.start !== previousEnd) {
        return false;
      }

      previousEnd = segment.end;
    }

    return previousEnd === 1440;
  }

  // Comprueba que las tareas cubren todas las horas de la semana sin solaparse
  checkTask(tasks) {
    if (!Array.isArray(tasks) || tasks.length == 0) return false;

    const weekDays = Object.keys(this.days);

    for (const day of weekDays) {
      const dayTasks = tasks.filter((task) => {
        const bitmask = task?.initTime?.weekday;
        if (typeof bitmask !== 'number') {
          return false;
        }

        const parsedDays = this._utils.setDaysFromBitmask(bitmask);
        return !!parsedDays?.[day];
      });

      if (dayTasks.length == 0) {
        return false;
      }

      if (!this.checkPowerTasks(dayTasks)) {
        return false;
      }
    }

    return true;
  }

  //Ordena las tareas primero por días de la semana y, dentro del mismo grupo, por hora de inicio.
  private sortTasksByHourMin(tasks: any[]): any[] {
    return [...tasks].sort((t1, t2) => {
      const weekdayOrder1 = this.getWeekdayOrder(t1?.initTime?.weekday);
      const weekdayOrder2 = this.getWeekdayOrder(t2?.initTime?.weekday);

      if (weekdayOrder1 !== weekdayOrder2) {
        return weekdayOrder1 - weekdayOrder2;
      }

      const t1HourMin = t1?.initTime?.timeList?.[0]?.hourMin ?? 0;
      const t2HourMin = t2?.initTime?.timeList?.[0]?.hourMin ?? 0;
      return t1HourMin - t2HourMin;
    });
  }

  // Obtiene el orden del día de la semana a partir del bitmask, donde lunes=0, martes=1,
  private getWeekdayOrder(bitmask: number): number {
    if (typeof bitmask !== 'number') {
      return Number.MAX_SAFE_INTEGER;
    }

    const weekDays = [
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday',
      'sunday',
    ];
    const parsedDays = this._utils.setDaysFromBitmask(bitmask);

    for (let i = 0; i < weekDays.length; i++) {
      if (parsedDays?.[weekDays[i]]) {
        return i;
      }
    }

    return Number.MAX_SAFE_INTEGER;
  }

  openEditTask(task) {
    const previousTask = JSON.parse(JSON.stringify(task));
    this.modalAdd = this._modal.open(ModalSchedulerTaskComponent);
    this.modalAdd.componentInstance.type = 1;
    this.modalAdd.componentInstance.task = JSON.parse(JSON.stringify(task));
    this.modalAdd.componentInstance.limitP = this.limitP;
    this.modalAdd.componentInstance.tasks = this.tasks;

    this.modalAdd.result.then(
      (updatedTask) => {
        const idx = this.tasks.findIndex((tk) => tk.id === updatedTask?.id);
        if (idx !== -1) {
          this.tasks[idx] = updatedTask;
        }

        console.log('upadate duration ', updatedTask);
        const previousStart = previousTask?.initTime?.timeList?.[0]?.hourMin;
        const updatedStart = updatedTask?.initTime?.timeList?.[0]?.hourMin;
        const previousDuration = previousTask?.initTime?.timeList?.[0]?.duration;
        const updatedDuration = updatedTask?.initTime?.timeList?.[0]?.duration;
        const previousWeekday = this.normalizeWeekdayMask(
          previousTask?.initTime?.weekday,
        );
        const updatedWeekday = this.normalizeWeekdayMask(
          updatedTask?.initTime?.weekday,
        );

        const structuralChanged =
          previousStart !== updatedStart ||
          previousDuration !== updatedDuration ||
          previousWeekday !== updatedWeekday;

        // Si solo cambian campos como potencia/prioridad, no se deben tocar otros tramos.
        if (!structuralChanged) {
          this.tasks = this.sortTasksByHourMin(this.tasks);
          this.madeChanges = true;
          return;
        }

        const updatedIsFull = this.isTareaCompleta(updatedTask);
        const previousIsFull = this.isTareaCompleta(previousTask);

        if (updatedIsFull && !previousIsFull) {
          // Antes necesitaba complementaria y ahora ya no.
          // 1) eliminar complementaria previa
          // 2) preservar días eliminados para no dejar huecos
          // 3) reconciliar weekday contra el resto
          const prevComplementSnapshot =
            this.getComplementariaSnapshot(previousTask);
          this.eliminarComplementariaDe(previousTask);
          const preservedIds = this.crearTareasResidualPorDias(
            previousTask,
            updatedTask,
            prevComplementSnapshot,
          );
          this.comprobarDiasTarea(updatedTask, [
            updatedTask?.id,
            ...preservedIds,
          ]);
        } else if (!updatedIsFull && previousIsFull) {
          // Antes era 24h y ahora ya no.
          // 1) preservar días eliminados para no dejar huecos
          // 2) reconciliar weekday
          // 3) crear complementaria nueva para el horario parcial
          const preservedIds = this.crearTareasResidualPorDias(
            previousTask,
            updatedTask,
            undefined,
          );
          this.comprobarDiasTarea(updatedTask, [
            updatedTask?.id,
            ...preservedIds,
          ]);
          this.completarTarea(updatedTask, false);
        } else if (!updatedIsFull && !previousIsFull) {
          // Seguía siendo parcial.
          // 1) actualizar complementaria existente (horario + weekday)
          // 2) preservar días quitados de la edición para no dejar huecos
          // 3) reconciliar weekday contra el resto
          const prevComplementSnapshot =
            this.getComplementariaSnapshot(previousTask);
          if (prevComplementSnapshot) {
            const complementId = this.actualizarComplementaria(
              updatedTask,
              previousTask,
            );
            const preservedIds = this.crearTareasResidualPorDias(
              previousTask,
              updatedTask,
              prevComplementSnapshot,
            );
            this.comprobarDiasTarea(updatedTask, [
              updatedTask?.id,
              complementId,
              ...preservedIds,
            ]);
          } else {
            // Caso general (>=3 tramos en el mismo weekday):
            // conservar exactamente el tramo editado y desplazar el siguiente.
            this.rebalanceEditedSegmentInGroup(updatedTask, previousTask);
          }
        } else {
          // Era 24h y sigue 24h.
          // 1) preservar días eliminados para no dejar huecos
          // 2) reconciliar weekday contra el resto
          const preservedIds = this.crearTareasResidualPorDias(
            previousTask,
            updatedTask,
            undefined,
          );
          this.comprobarDiasTarea(updatedTask, [
            updatedTask?.id,
            ...preservedIds,
          ]);
        }

        this.tasks = this.sortTasksByHourMin(this.tasks);
        this.madeChanges = true;

        // const previousWeekday = previousTask?.initTime?.weekday;
        // const newWeekday = updatedTask?.initTime?.weekday;
        // const previousStart = previousTask?.initTime?.timeList?.[0]?.hourMin;
        // const newStart = updatedTask?.initTime?.timeList?.[0]?.hourMin;

        // const weekdayChanged = previousWeekday !== newWeekday;
        // const startChanged = previousStart !== newStart;

        // if (weekdayChanged) {
        //   this.rebalanceByWeekday(previousWeekday);
        //   this.rebalanceByWeekday(newWeekday);
        // } else if (startChanged) {
        //   this.rebalanceByWeekday(newWeekday);
        // }

        // this.tasks = this.sortTasksByHourMin(this.tasks);
      },
      (reason) => {
        const idx = this.tasks.findIndex((tk) => tk.id === previousTask?.id);
        if (idx !== -1) {
          this.tasks[idx] = previousTask;
        }
      },
    );
  }

  eliminarComplementariaDe(task) {
    const start = task?.initTime?.timeList?.[0]?.hourMin;
    const duration = task?.initTime?.timeList?.[0]?.duration;
    const rawWeekday = task?.initTime?.weekday;

    if (
      typeof start !== 'number' ||
      typeof duration !== 'number' ||
      duration <= 0 ||
      duration >= 1440 ||
      typeof rawWeekday !== 'number'
    ) {
      return false;
    }

    const weekday = rawWeekday === 0 ? 127 : rawWeekday & 127;
    const expectedComplementStart = (start + duration) % 1440;
    const expectedComplementDuration = 1440 - duration;

    const idxComplement = this.tasks.findIndex((candidate) => {
      if (!candidate || candidate.id === task.id) return false;

      const candidateStart = candidate?.initTime?.timeList?.[0]?.hourMin;
      const candidateDuration = candidate?.initTime?.timeList?.[0]?.duration;
      const candidateRawWeekday = candidate?.initTime?.weekday;

      if (
        typeof candidateStart !== 'number' ||
        typeof candidateDuration !== 'number' ||
        typeof candidateRawWeekday !== 'number'
      ) {
        return false;
      }

      const candidateWeekday =
        candidateRawWeekday === 0 ? 127 : candidateRawWeekday & 127;

      // Como la complementaria se crea clonando atributos, igualamos también metadatos clave.
      return (
        candidateStart === expectedComplementStart &&
        candidateDuration === expectedComplementDuration &&
        candidateWeekday === weekday &&
        candidate.type === task.type &&
        candidate.group === task.group &&
        candidate.priority === task.priority &&
        candidate.solarPriority === task.solarPriority &&
        candidate.maxPower === task.maxPower
      );
    });

    if (idxComplement === -1) return false;

    this.tasks.splice(idxComplement, 1);
    return true;
  }

  actualizarComplementaria(updatedTask, previousTask) {
    const updatedStart = updatedTask?.initTime?.timeList?.[0]?.hourMin;
    const updatedDuration = updatedTask?.initTime?.timeList?.[0]?.duration;
    const updatedRawWeekday = updatedTask?.initTime?.weekday;

    if (
      typeof updatedStart !== 'number' ||
      typeof updatedDuration !== 'number' ||
      updatedDuration <= 0 ||
      updatedDuration >= 1440 ||
      typeof updatedRawWeekday !== 'number'
    ) {
      return undefined;
    }

    const expectedNewStart = (updatedStart + updatedDuration) % 1440;
    const expectedNewDuration = 1440 - updatedDuration;

    const prevStart = previousTask?.initTime?.timeList?.[0]?.hourMin;
    const prevDuration = previousTask?.initTime?.timeList?.[0]?.duration;
    const prevRawWeekday = previousTask?.initTime?.weekday;

    if (
      typeof prevStart !== 'number' ||
      typeof prevDuration !== 'number' ||
      typeof prevRawWeekday !== 'number'
    ) {
      return undefined;
    }

    const prevWeekday = prevRawWeekday === 0 ? 127 : prevRawWeekday & 127;
    const expectedPrevCompStart = (prevStart + prevDuration) % 1440;
    const expectedPrevCompDuration = 1440 - prevDuration;

    const idxComplement = this.tasks.findIndex((candidate) => {
      if (!candidate || candidate.id === updatedTask?.id) return false;

      const candidateStart = candidate?.initTime?.timeList?.[0]?.hourMin;
      const candidateDuration = candidate?.initTime?.timeList?.[0]?.duration;
      const candidateRawWeekday = candidate?.initTime?.weekday;

      if (
        typeof candidateStart !== 'number' ||
        typeof candidateDuration !== 'number' ||
        typeof candidateRawWeekday !== 'number'
      ) {
        return false;
      }

      const candidateWeekday =
        candidateRawWeekday === 0 ? 127 : candidateRawWeekday & 127;

      return (
        candidateStart === expectedPrevCompStart &&
        candidateDuration === expectedPrevCompDuration &&
        candidateWeekday === prevWeekday &&
        candidate.type === previousTask?.type &&
        candidate.group === previousTask?.group &&
        candidate.priority === previousTask?.priority &&
        candidate.solarPriority === previousTask?.solarPriority &&
        candidate.maxPower === previousTask?.maxPower
      );
    });

    if (idxComplement === -1) {
      const newTask = {
        id: this.getFreeIdFromTasks(),
        user: updatedTask.user,
        active: 1,
        group: updatedTask.group,
        type: updatedTask.type,
        maxPower: updatedTask.maxPower,
        priority: updatedTask.priority,
        solarPriority: updatedTask.solarPriority,
        initTime: {
          day: updatedTask.initTime.day,
          month: updatedTask.initTime.month,
          weekday: updatedTask.initTime.weekday,
          timeList: [
            {
              hourMin: expectedNewStart,
              duration: expectedNewDuration,
              maxPower: updatedTask.maxPower,
              phases: 0,
            },
          ],
        },
      };
      this.tasks.push(newTask);
      return newTask.id;
    }

    const complement = this.tasks[idxComplement];
    complement.user = updatedTask.user;
    complement.active = 1;
    complement.group = updatedTask.group;
    complement.type = updatedTask.type;
    complement.maxPower = updatedTask.maxPower;
    complement.priority = updatedTask.priority;
    complement.solarPriority = updatedTask.solarPriority;
    complement.initTime.day = updatedTask.initTime.day;
    complement.initTime.month = updatedTask.initTime.month;
    complement.initTime.weekday = updatedTask.initTime.weekday;
    complement.initTime.timeList[0].hourMin = expectedNewStart;
    complement.initTime.timeList[0].duration = expectedNewDuration;
    complement.initTime.timeList[0].maxPower = updatedTask.maxPower;
    complement.initTime.timeList[0].phases = 0;
    return complement.id;
  }

  // Distribuye los días huérfanos al grupo de tareas con menor distancia de calendario.
  // En caso de empate, prefiere el grupo con menos días (más específico).
  private distribuirDiasHuerfanos(
    orphanedWeekday: number,
    tasks: any[],
  ): any[] {
    if (orphanedWeekday === 0 || tasks.length === 0) return tasks;

    // Obtener grupos únicos por bitmask
    const groupMasks = Array.from(
      new Set(
        tasks.map((t) => this.normalizeWeekdayMask(t?.initTime?.weekday)),
      ),
    );

    const getDayIndices = (mask: number): number[] => {
      const days: number[] = [];
      for (let i = 0; i < 7; i++) {
        if (mask & (1 << i)) days.push(i);
      }
      return days;
    };

    const circularDistance = (a: number, b: number): number => {
      const diff = Math.abs(a - b);
      return Math.min(diff, 7 - diff);
    };

    const orphanedDays = getDayIndices(orphanedWeekday);

    let bestMask = groupMasks[0];
    let bestDistance = Infinity;
    let bestDayCount = Infinity;

    groupMasks.forEach((groupMask) => {
      const groupDays = getDayIndices(groupMask);
      // Distancia mínima entre cualquier día huérfano y cualquier día del grupo
      let minDist = Infinity;
      orphanedDays.forEach((od) => {
        groupDays.forEach((gd) => {
          const dist = circularDistance(od, gd);
          if (dist < minDist) minDist = dist;
        });
      });

      const dayCount = groupDays.length;
      // Preferir menor distancia; en empate, grupo más específico (menos días)
      if (
        minDist < bestDistance ||
        (minDist === bestDistance && dayCount < bestDayCount)
      ) {
        bestDistance = minDist;
        bestMask = groupMask;
        bestDayCount = dayCount;
      }
    });

    const newMask = bestMask | orphanedWeekday;
    tasks.forEach((t) => {
      if (this.normalizeWeekdayMask(t?.initTime?.weekday) === bestMask) {
        t.initTime.weekday = newMask;
      }
    });

    return tasks;
  }

  private normalizeWeekdayMask(rawWeekday: any): number {
    if (typeof rawWeekday !== 'number') return 0;
    return rawWeekday === 0 ? 127 : rawWeekday & 127;
  }

  private getComplementariaSnapshot(task) {
    const start = task?.initTime?.timeList?.[0]?.hourMin;
    const duration = task?.initTime?.timeList?.[0]?.duration;
    const weekday = this.normalizeWeekdayMask(task?.initTime?.weekday);

    if (
      typeof start !== 'number' ||
      typeof duration !== 'number' ||
      duration <= 0 ||
      duration >= 1440 ||
      weekday === 0
    ) {
      return undefined;
    }

    const expectedCompStart = (start + duration) % 1440;
    const expectedCompDuration = 1440 - duration;

    const idx = this.tasks.findIndex((candidate) => {
      if (!candidate || candidate.id === task?.id) return false;

      const cStart = candidate?.initTime?.timeList?.[0]?.hourMin;
      const cDuration = candidate?.initTime?.timeList?.[0]?.duration;
      const cWeekday = this.normalizeWeekdayMask(candidate?.initTime?.weekday);

      if (
        typeof cStart !== 'number' ||
        typeof cDuration !== 'number' ||
        cWeekday === 0
      ) {
        return false;
      }

      return (
        cStart === expectedCompStart &&
        cDuration === expectedCompDuration &&
        cWeekday === weekday &&
        candidate.type === task?.type &&
        candidate.group === task?.group &&
        candidate.priority === task?.priority &&
        candidate.solarPriority === task?.solarPriority &&
        candidate.maxPower === task?.maxPower
      );
    });

    if (idx === -1) return undefined;
    return JSON.parse(JSON.stringify(this.tasks[idx]));
  }

  private crearTareasResidualPorDias(
    previousTask,
    updatedTask,
    previousComplementSnapshot,
  ): number[] {
    const prevWeekday = this.normalizeWeekdayMask(
      previousTask?.initTime?.weekday,
    );
    const newWeekday = this.normalizeWeekdayMask(
      updatedTask?.initTime?.weekday,
    );
    const removedWeekday = prevWeekday & (~newWeekday & 127);

    if (removedWeekday === 0) return [];

    const createdIds: number[] = [];

    const residualMain = JSON.parse(JSON.stringify(previousTask));
    residualMain.id = this.getFreeIdFromTasks();
    residualMain.initTime.weekday = removedWeekday;
    this.tasks.push(residualMain);
    createdIds.push(residualMain.id);

    if (previousComplementSnapshot) {
      const residualComplement = JSON.parse(
        JSON.stringify(previousComplementSnapshot),
      );
      residualComplement.id = this.getFreeIdFromTasks();
      residualComplement.initTime.weekday = removedWeekday;
      this.tasks.push(residualComplement);
      createdIds.push(residualComplement.id);
    }

    return createdIds;
  }

  // Rebalanceo específico de edición en grupos multitramos.
  // Mantiene el tramo editado (inicio + duración) y desplaza el siguiente tramo al nuevo fin.
  private rebalanceEditedSegmentInGroup(
    updatedTask: any,
    previousTask: any,
  ): void {
    const updatedMask = this.normalizeWeekdayMask(
      updatedTask?.initTime?.weekday,
    );
    const previousMask = this.normalizeWeekdayMask(
      previousTask?.initTime?.weekday,
    );

    if (updatedMask !== previousMask) {
      const masksToRebalance = new Set<number>([previousMask, updatedMask]);
      masksToRebalance.forEach((mask) => {
        if (mask === 0) return;
        const affected = this.tasks.filter(
          (t) => this.normalizeWeekdayMask(t?.initTime?.weekday) === mask,
        );
        if (affected.length === 0) return;
        const others = this.tasks.filter(
          (t) => this.normalizeWeekdayMask(t?.initTime?.weekday) !== mask,
        );
        this.adjustPowerTasks(affected);
        this.tasks = [...others, ...affected];
      });
      return;
    }

    if (updatedMask === 0) return;

    const affected = this.tasks.filter(
      (t) => this.normalizeWeekdayMask(t?.initTime?.weekday) === updatedMask,
    );
    if (affected.length <= 1) return;

    affected.sort((a, b) => {
      const aStart = a?.initTime?.timeList?.[0]?.hourMin ?? 0;
      const bStart = b?.initTime?.timeList?.[0]?.hourMin ?? 0;
      return aStart - bStart;
    });

    const editedIndex = affected.findIndex((t) => t?.id === updatedTask?.id);
    if (editedIndex === -1) return;

    const edited = affected[editedIndex];
    const editedStart = edited?.initTime?.timeList?.[0]?.hourMin;
    const editedDuration = edited?.initTime?.timeList?.[0]?.duration;

    if (
      typeof editedStart !== 'number' ||
      typeof editedDuration !== 'number' ||
      editedDuration <= 0 ||
      editedDuration > 1440
    ) {
      return;
    }

    const nextIndex = (editedIndex + 1) % affected.length;
    const nextTask = affected[nextIndex];
    if (!nextTask?.initTime?.timeList?.[0]) return;

    const newNextStart = (editedStart + editedDuration) % 1440;
    nextTask.initTime.timeList[0].hourMin = newNextStart;

    this.adjustPowerTasks(affected);

    const others = this.tasks.filter(
      (t) => this.normalizeWeekdayMask(t?.initTime?.weekday) !== updatedMask,
    );
    this.tasks = [...others, ...affected];
  }

  restore() {
    // originalTasks siempre tiene mennekes1 o mennekes como clave
    const originalData =
      this.originalTasks['mennekes1'] || this.originalTasks['mennekes'];

    if (!originalData) {
      return;
    }
    const compareData = JSON.parse(JSON.stringify(originalData));

    this.tasks = compareData.filter((task: any) => task.type == 1);

    if (this.versionNewSchedulers) {
      compareData.forEach((task) => {
        if (task?.initTime?.timeList[0])
          task.maxPower = task.initTime.timeList[0].maxPower;
      });
    }

    this.tasks = this.sortTasksByHourMin(this.tasks);

    this.madeChanges = false;
  }

  checkChanges(index: number): void {
    const originalTask = this.originalTasks['mennekes'] || this.originalTasks['mennekes1'];
    if (this.tasks[index].maxPower !== originalTask[index].maxPower) {
      this.madeChanges = true;
    }
  }
}

